/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-06 11:39:10
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { getFormValues, change } from 'redux-form';

import RuleGroupList from 'src/components/views/recommendation/widget/item/general/rule-group-list';

import type { RuleGroupListType } from 'src/models/recommendation';

type PropsFromState = {
  rules: RuleGroupListType
};

type PropsFromDispatch = {
  updateField: Function
};

type ComposedProps = WithI18nProps & PropsFromDispatch & PropsFromState;

class RuleGroupListContainer extends Component<ComposedProps, State> {
  render() {
    return <RuleGroupList {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateRulesField: data => dispatch(change(`RecommendationGeneralWidgetItemForm`, 'rules', data))
});

const mapStateToProps = (state, props) => {
  const formValues = getFormValues('RecommendationGeneralWidgetItemForm')(state) || {};
  const rules = _.get(formValues, 'rules', []);
  return {
    rules
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(RuleGroupListContainer));
